import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import ProgressBar from '@wix/da-ds/pkg/ProgressBar/ProgressBar';

import s from './UploadingLoader.scss';

interface Props {
  uploadProgress?: number;
  isOriginals?: boolean;
}

const UploadingLoader: React.FC<Props> = ({ uploadProgress, isOriginals }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <Loader size="big" state={isOriginals ? 'painting_brush' : 'eating'} />
      {uploadProgress ? (
        <ProgressBar progress={uploadProgress} className={s['progress-bar']} />
      ) : null}
      <div className={s['progress-title']}>
        {isOriginals ? t('uploadZone.progress.title.originals') : t('uploadZone.progress.title')}
      </div>
    </div>
  );
};

export default UploadingLoader;
